module.exports = __webpack_public_path__ + "media/images/best-of-year-01ff0593b3c06e87cc2c5ba190eb34e6.png";